'use client';

import React from 'react';
import Image from 'next/image';
import s from './styles.module.scss';
import { useModal } from '../../ui/ModalProvider';
import FancyButton from '../../ui/FancyButton';
import { useViewport } from '@/src/lib/useViewport';

const BP = 786;

export const Header = () => {
    const { openModal } = useModal();
    const { mounted, vw, isMobile } = useViewport(BP);

    if (!mounted || vw === null) {
        return <div className={s.root} />;
    }

    return (
        <header className={s.rootHeader}>
            <div className={s.bgWrap}>
                <Image
                    src="/icons/header.svg"
                    alt=""
                    fill
                    priority
                    sizes="100vw"
                    className={s.bg}
                />

                <div className={s.container}>
                    <Image
                        src="/icons/logo.svg"
                        alt="Logo"
                        width={96}
                        height={40}
                        className={s.logo}
                        sizes="(max-width: 600px) 36px, (max-width: 1200px) 6vw, 52px"
                    />

                    <p>“for those who live to the fullest”</p>

                    {isMobile ? (
                        <FancyButton
                            normalSvg="/icons/btn_orange.svg"
                            hoverSvg="/icons/btn_orange_active.svg"
                            width={175}
                            height={44}
                            fit="fill"
                            onClick={openModal}
                            className={s.buttonFancy}
                        />
                        ):(
                        <FancyButton
                            normalSvg="/icons/btn_orange.svg"
                            hoverSvg="/icons/btn_orange_active.svg"
                            width={219.2}
                            height={65.4}
                            fit="fill"
                            onClick={openModal}
                            className={s.buttonFancy}
                        />
                    )}


                </div>
            </div>
        </header>
    );
};
